module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.linhaDoTempo) ? _c('div', {
    class: ['linha-do-tempo-da-solicitacao', _vm.modificadorDoDestaque]
  }, [_c('ol', {
    staticClass: "linha-do-tempo-da-solicitacao__regua",
    attrs: {
      "aria-label": "Linha do tempo da solicitação"
    }
  }, _vm._l((_vm.linhaDoTempo.TotalDeEtapas), function(numero) {
    return _c('li', {
      key: numero,
      staticClass: "linha-do-tempo-da-solicitacao__etapa"
    }, [(_vm.deveExibirBadgeNaEtapa(numero)) ? _c('span', {
      staticClass: "linha-do-tempo-da-solicitacao__badge"
    }, [_c('span', {
      staticClass: "linha-do-tempo-da-solicitacao__badge-rotulo"
    }, [_vm._v(_vm._s(_vm.linhaDoTempo.NomeDaEtapaAtual))]), _vm._v(" "), _c('svg', {
      staticClass: "linha-do-tempo-da-solicitacao__badge-seta",
      attrs: {
        "width": "6.9282",
        "height": "6",
        "viewBox": "0 0 6.9282 6",
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "aria-hidden": "true",
        "focusable": "false"
      }
    }, [_c('path', {
      attrs: {
        "d": "M3.4641 0L6.9282 6H0L3.4641 0Z",
        "fill": "currentColor"
      }
    })])]) : _vm._e(), _vm._v(" "), _c('span', {
      class: ['linha-do-tempo-da-solicitacao__segmento', _vm.classeDoSegmento(numero)]
    })])
  }), 0), _vm._v(" "), (_vm.estaEmAndamento) ? _c('div', {
    staticClass: "linha-do-tempo-da-solicitacao__rodape"
  }, [_c('span', {
    staticClass: "titulo titulo_micro linha-do-tempo-da-solicitacao__vizinha"
  }, [_vm._v("Etapa anterior: " + _vm._s(_vm.linhaDoTempo.NomeDaEtapaAnterior))]), _vm._v(" "), _c('span', {
    staticClass: "titulo titulo_micro linha-do-tempo-da-solicitacao__posicao"
  }, [_vm._v("Etapa " + _vm._s(_vm.linhaDoTempo.NumeroDaEtapaAtual) + " de " + _vm._s(_vm.linhaDoTempo.TotalDeEtapas))]), _vm._v(" "), _c('span', {
    staticClass: "titulo titulo_micro linha-do-tempo-da-solicitacao__vizinha linha-do-tempo-da-solicitacao__vizinha_proxima"
  }, [_vm._v("Próxima etapa: " + _vm._s(_vm.linhaDoTempo.NomeDaProximaEtapa))])]) : (_vm.possuiDesfecho) ? _c('div', {
    staticClass: "linha-do-tempo-da-solicitacao__desfecho"
  }, [_c('i', {
    class: ['linha-do-tempo-da-solicitacao__desfecho-icone', 'fas', _vm.iconeDoDesfecho],
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "titulo titulo_micro"
  }, [_vm._v(_vm._s(_vm.textoDoDesfecho))])]) : _c('div', {
    staticClass: "linha-do-tempo-da-solicitacao__desfecho linha-do-tempo-da-solicitacao__desfecho_sem-etapa"
  }, [_c('span', {
    staticClass: "titulo titulo_micro"
  }, [_vm._v("Situação não encontrada")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10fceabe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/LinhaDoTempoDaSolicitacao.vue
// module id = 1089
// module chunks = 1